import { useTranslation } from 'next-i18next';
import React from 'react';

import { NS } from '@/constants';
import { ANIMATION } from '@/constants/animation';
import { useAnimation } from '@/hooks';
import { useAppDispatch } from '@/redux';

import { toggleDeliveryScheduleModal } from '@/redux/slices/gui.slice';

import { ModalHeaderDsProps } from '@/components/layout/modals/ModalHeader.ds';
import { ModalFooterDsProps } from '@/components/layout/modals/ModalFooter.ds';
import FullScreenContainerV2 from '@/components/layout/modals/FullScreenContainerV2';
import DeliveryScheduleDateSelector from '@/components/checkout/shipMode/DeliverySelector/DeliveryScheduleDateSelector';

import styles from './DeliveryScheduleModal.module.scss';

const FORM_ID = 'timeslot';

type DeliveryScheduleModalProps = {
  data: any;
  onSelectedSlot: (slot) => void;
  isExproCheckout: boolean;
  isOpen?: boolean;
  isDayOnly: boolean;
}

export const DeliveryScheduleModal = (
  { data, onSelectedSlot, isExproCheckout, isOpen, isDayOnly }: DeliveryScheduleModalProps
): React.JSX.Element => {
  const { t } = useTranslation(NS.CHECKOUT);
  const dispatch = useAppDispatch();
  const { animationState: animation, handleCloseModal } = useAnimation({});

  const closeModal = () => {
    handleCloseModal();
    setTimeout(() => {
      dispatch(toggleDeliveryScheduleModal({ opened: false, shippingId: '' }));
    }, ANIMATION.DELAY);
  };

  const headlineProps = {
    onCloseClick: closeModal,
    title: isDayOnly ? t('shipMode.topChrono.chooseDate') : t('shipMode.topChrono.chooseDateAndSlot')
  } as ModalHeaderDsProps;
  const footerProps = {
    confirm: {
      label: isDayOnly ? t('shipMode.topChrono.confirmDate') : t('shipMode.topChrono.confirmSlot'),
      formId: FORM_ID
    }
  } as ModalFooterDsProps;

  return (
    <FullScreenContainerV2
      onClose={closeModal}
      overlay
      padding="md"
      classNames={{ container: styles.container }}
      animationClass={animation}
      designSystemHeader={headlineProps}
      designSystemFooter={footerProps}
      isOpen={isOpen}
    >
      <DeliveryScheduleDateSelector
        data={data}
        onSelectedSlot={onSelectedSlot}
        withPadding
        isExproCheckout={isExproCheckout}
        isDayOnly={isDayOnly}
      />
    </FullScreenContainerV2>
  );
};

export default DeliveryScheduleModal;
